<template>
	<div class="aurora-home">
		<section class="aurora-home__stage">
			<div class="aurora-home__background">
				<div class="aurora-home__aurora"></div>
			</div>

			<div class="aurora-home__shell">
				<div class="aurora-home__content">
					<div class="aurora-home__brand">
						<span class="aurora-home__brand-accent">银合</span><span class="aurora-home__brand-muted">Pilot</span>
					</div>
					<h1>
						<span class="aurora-home__headline-light">专注于给中小企业降本增效</span>
						<br>
						<span class="aurora-home__headline-light">的</span><span class="aurora-home__headline-strong">数字员工平台</span>
					</h1>
					<p class="aurora-home__subtitle">
						用对话和文件即可完成日常财务工作，支持老板、行政和出纳直接交办任务，自动承接凭证处理、税务申报、工资核算和日常提醒，把复杂财务工作变成一句话和一份文件。
					</p>
					<div class="aurora-home__highlights">
						<span v-for="item in highlights" :key="item">{{ item }}</span>
					</div>
				</div>

				<div class="aurora-home__visual">
					<div class="aurora-home__dialog">
						<div class="aurora-home__dialog-bar">
							<div class="aurora-home__dialog-dots">
								<span></span>
								<span></span>
								<span></span>
							</div>
							<div class="aurora-home__dialog-title">TAXPILOT · CONVERSATION</div>
						</div>
						<div class="aurora-home__dialog-body">
							<div
								v-for="item in conversationMessages"
								:key="item.id"
								:class="['aurora-home__message', `aurora-home__message--${item.role}`]"
							>
								<div :class="['aurora-home__message-bubble', item.emphasis ? `aurora-home__message-bubble--${item.emphasis}` : '']">
									<div class="aurora-home__message-text">{{ item.text }}</div>
								</div>
							</div>
						</div>
						<div class="aurora-home__dialog-composer">
							<div class="aurora-home__dialog-composer-input">
								<div class="aurora-home__dialog-composer-draft">
									<span>{{ composerDisplayText }}</span><span class="aurora-home__dialog-composer-cursor">_</span>
								</div>
								<div class="aurora-home__dialog-composer-send">↗</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'SiteOverview',
	data() {
		return {
			highlights: ['对话式处理', '自动记账报税', '主动提醒风险'],
			conversationMessages: [
				{
					id: 'reminder',
					role: 'assistant',
					text: '主动提醒：今天 16:30 前要完成本月个税申报，工资表和社保基数我已经核对完，凭证草稿也整理好了。是否现在提交并同步生成提醒记录？'
				},
				{
					id: 'confirm',
					role: 'user',
					text: '可以，直接处理。'
				},
				{
					id: 'done',
					role: 'assistant',
					emphasis: 'report',
					text: '处理完成：\n1. 个税申报已提交\n2. 工资核算结果已归档\n3. 凭证已生成并待你复核\n4. 下周社保扣款时间已加入提醒'
				}
			],
			composerDrafts: [
				'好的，提交后把回执、凭证编号和风险提示一起发我。',
				'把这次申报结果同步给行政，并提醒下周社保扣款时间。',
				'凭证复核通过后，顺手把老板简报也整理一版。'
			],
			composerDisplayText: '',
			composerDraftIndex: 0,
			composerCharIndex: 0,
			composerDeleting: false,
			composerTimer: null
		};
	},
	mounted() {
		this.queueComposerTick(800);
	},
	beforeDestroy() {
		if (this.composerTimer) {
			clearTimeout(this.composerTimer);
			this.composerTimer = null;
		}
	},
	methods: {
		queueComposerTick(delay) {
			if (this.composerTimer) {
				clearTimeout(this.composerTimer);
			}
			this.composerTimer = setTimeout(this.stepComposerDraft, delay);
		},
		stepComposerDraft() {
			const currentText = this.composerDrafts[this.composerDraftIndex];
			if (!currentText) {
				return;
			}

			if (this.composerDeleting) {
				if (this.composerDisplayText.length === 0) {
					this.composerDeleting = false;
					this.composerDraftIndex = (this.composerDraftIndex + 1) % this.composerDrafts.length;
					this.composerCharIndex = 0;
					this.queueComposerTick(300);
					return;
				}

				this.composerDisplayText = this.composerDisplayText.slice(0, -1);
				this.composerCharIndex = Math.max(this.composerCharIndex - 1, 0);
				this.queueComposerTick(32);
				return;
			}

			if (this.composerCharIndex < currentText.length) {
				this.composerDisplayText += currentText[this.composerCharIndex];
				this.composerCharIndex += 1;
				this.queueComposerTick(58);
				return;
			}

			this.composerDeleting = true;
			this.queueComposerTick(1700);
		}
	}
};
</script>
